export const NUMBER_OF_SENT_MESSAGES_FOR_REVIEW = 5;
